import { useState, FC, ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { Checkbox } from "@mui/material";

import MDButton from "components/MDButton";
import { CameraDeniedModal } from "components/CameraDeniedModal/CameraDeniedModal";
import { checkCameraPermission } from "utils/camera.util";
import { useMaterialUIController } from "context";
import { makeStyles } from "tss-react/mui";
import TermsModal from "./TermsModal";
import { styles } from "./TermsAndConditions.styles";

interface StepProps {
  handleUpdateStep: (step: number) => void;
}

const HOME_PAGE_PREFIX = "FOB:homePage";

const TermsAndConditions: FC<StepProps> = ({ handleUpdateStep }) => {
  const [permisionDeniedVissible, setPermisionDeniedVissible] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [enableNext, setEnableNext] = useState(false);
  const [{ direction }] = useMaterialUIController();
  const theme = useTheme();
  const useStyles = makeStyles()(() => styles(theme));
  const { classes } = useStyles();
  const { t } = useTranslation();

  const handleCheckTerms = (event: ChangeEvent<HTMLInputElement>) => {
    setEnableNext(event.target.checked);
  };

  const handleOpenTermsModal = () => {
    setIsTermsModalOpen(true);
  };

  const handleCloseTermsModal = () => {
    setIsTermsModalOpen(false);
  };

  const handleTermsLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
    handleOpenTermsModal();
  };

  const goNextStep = async () => {
    try {
      await checkCameraPermission();
      setPermisionDeniedVissible(false);
      handleUpdateStep(1);
    } catch {
      setPermisionDeniedVissible(true);
    }
  };

  if (permisionDeniedVissible) {
    return <CameraDeniedModal tryAgain={() => handleUpdateStep(1)} />;
  }

  return (
    <div className={classes.container} data-test-id="terms-and-conditions">
      <div className={classes.bodyContainer}>
        <div className={classes.bodyContent}>
          <div className={classes.consentCard} data-test-id="terms-consent-card">
            <div className={classes.consentRow}>
              <Checkbox
                color="primary"
                classes={{
                  root:
                    direction === "ltr" ? classes.checkBoxLTR : classes.checkBoxRTL,
                }}
                onChange={handleCheckTerms}
                data-test-id="terms-and-conditions-checkbox"
                id="terms-and-conditions-checkbox"
                // className={classes.consentCheckbox}
              />
              <label htmlFor="terms-and-conditions-checkbox" className={classes.consentLabel}>
                {t(`${HOME_PAGE_PREFIX}:termsCheckboxPrefix`)}
                <a
                  onClick={handleTermsLinkClick}
                  className={classes.termsLink}
                  
                  data-test-id="terms-and-conditions-link"
                >
                  {t(`${HOME_PAGE_PREFIX}:termsCheckboxLink`)}
                </a>
              </label>
            </div>
            <div className={classes.consentMeta} data-test-id="terms-consent-meta">
              {t(`${HOME_PAGE_PREFIX}:consentMeta`)}
            </div>
          </div>
        </div>
      </div>

      <MDButton
        style={{ width: theme.width.full, height: theme.spacing.spacing28 }}
        color="primary"
        variant="contained"
        type="submit"
        onClick={goNextStep}
        disabled={!enableNext}
        data-test-id="terms-and-conditions-next"
      >
        {t(`${HOME_PAGE_PREFIX}:submitButton`)}
      </MDButton>

      <TermsModal isOpen={isTermsModalOpen} onClose={handleCloseTermsModal} />
    </div>
  );
};

export default TermsAndConditions;
